module.exports = __webpack_public_path__ + "img/delete.a16ce1a8.svg";